var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-calendar',{attrs:{"min-date":_vm.minDate,"type":"range","round":_vm.round,"allowSameDay":_vm.allowSameDay},on:{"confirm":_vm.onConfirm},model:{value:(_vm.showDate),callback:function ($$v) {_vm.showDate=$$v},expression:"showDate"}})
}
var staticRenderFns = []

export { render, staticRenderFns }